import { SITE_VOICE } from '../siteVoice';

export const gridDemo = {
  demoText: SITE_VOICE.welcomePhrase,
  hoverPrompt: 'Hover over a cell',
  cellLabel: 'Cell',
  addText: 'Add text',
  clear: 'Clear',
  drawHint: 'Click cells to draw',
} as const;
